import { ModuleName, SubModuleName } from "./types";
import { api } from "../evergis/api";

const PUBLIC_MODULES_PATH: Record<ModuleName | SubModuleName, string> = {
  [ModuleName.Catalog]: "Catalog/Catalog",
  [ModuleName.FeatureCard]: "FeatureCard/FeatureCard",
  [ModuleName.LayerList]: "LayerList/LayerList",
  [ModuleName.SharedLayerList]: "LayerList/LayerList",
  [ModuleName.Map]: "Map/Map",
  [ModuleName.Notifications]: "Notifications/Notifications",
  [ModuleName.Print]: "Print/Print",
  [ModuleName.ProjectPanel]: "ProjectPanel/ProjectPanel",
  [ModuleName.AddressSearch]: "MapControls/AddressSearch",
  [ModuleName.BasemapSelect]: "MapControls/BasemapSelect",
  [ModuleName.BookmarkControl]: "MapControls/BookmarkControl",
  [ModuleName.MeasurerControl]: "MapControls/MeasureControl",
  [ModuleName.ScaleControl]: "MapControls/ScaleControl",
  [ModuleName.DateFilterControl]: "MapControls/DateFilter",
  [ModuleName.GeoLocation]: "MapControls/GeoLocation",
  [ModuleName.Snapping]: "MapControls/Snapping",
  [ModuleName.ZoomSelection]: "MapControls/ZoomSelection",
  [ModuleName.Style]: "Style/Style",
  [ModuleName.StyleEditor]: "StyleEditor/StyleEditor",
  [ModuleName.Dashboard]: "Dashboard/Dashboard",
  [ModuleName.Presentation]: "Dashboard/Presentation",
  [ModuleName.LayerConfiguration]: "Configuration/LayerConfiguration",
  [ModuleName.ProjectConfiguration]: "Configuration/ProjectConfiguration",
  [ModuleName.ConfigurationsTable]: "Table/Table",
  [ModuleName.EqlQuery]: "EqlQuery/EqlQuery",
  [ModuleName.EqlLayerTable]: "Table/Table",
  [ModuleName.EqlQueryTable]: "Table/QueryTable",
  [ModuleName.SymbolLibrary]: "SymbolLibrary/SymbolLibrary",
  [ModuleName.Table]: "Table/Table",
  [ModuleName.DateFilter]: "DateFilter/DateFilter",
  [ModuleName.Tools]: "Tools/Tools",
  [ModuleName.Feedback]: "Feedback/Feedback",
  [ModuleName.Help]: "Help/Help",
  [SubModuleName.FeatureSelector]: "FeatureSelector/FeatureSelector",
  [SubModuleName.PrintArea]: "PrintArea/PrintArea",
};

const SHARED_MODULES_PATH: Partial<Record<ModuleName | SubModuleName, string>> = {
  [ModuleName.Map]: "SharedMap/SharedMap",
  [ModuleName.ProjectPanel]: "SharedProjectPanel/SharedProjectPanel",
  [ModuleName.LayerList]: "LayerList/LayerList",
  [ModuleName.BasemapSelect]: "SharedMapControls/BasemapSelect",
  [ModuleName.BookmarkControl]: "SharedMapControls/BookmarkControl",
  [SubModuleName.FeatureSelector]: "FeatureSelector/FeatureSelector",
};

export const MODULES_PATH = api.isShared ? { ...PUBLIC_MODULES_PATH, ...SHARED_MODULES_PATH } : PUBLIC_MODULES_PATH;
